import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy, isPlatform } from '@ionic/angular';

import {
  TranslateDefaultParser,
  TranslateLoader,
  TranslateModule,
  TranslateParser,
  TranslateService // me
} from '@ngx-translate/core';

import { AppRoutingModule } from './app-routing.module';

import { IonicConfig } from '@ionic/core';

///# import { FileOpener } from '@ionic-native/file-opener/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

import { LaunchReview } from '@awesome-cordova-plugins/launch-review/ngx';

import {environment} from 'environment';
import { initializeApp } from 'firebase/app';

///# import { HTTP } from '@ionic-native/http/ngx';
import { IonicStorageModule } from '@ionic/storage-angular';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';

import {AuthRequest} from 'shared/auth-request/auth-request';
import {FCMService} from 'shared/fcm/fcm.service';
import {LocalSettingsService} from './shared/local-settings/local-settings.service';
import {NavService} from './shared/nav/nav.service';

import {BadgeModule} from 'app/badge';
import {ContentModule} from 'app/content';
import {DashboardModule} from 'app/dashboard';
import {DialogsModule} from 'app/dialogs';
import {HistoryModule} from 'app/history';
import { InsightsModule } from 'app/insights';
import {CredentialsService, LoginModule} from 'app/login';
import {ProfileModule, UserService} from 'app/profile';
import {MenuModule} from 'app/menu';
import {SearchModule} from 'app/search';
import {TipsModule} from 'app/tips';
import {ApptextModule} from 'shared/apptext';
import {LeadaComponentsModule} from 'shared/components';
import {DaytimeModule} from 'shared/daytime';
import {NativeHttpInterceptor} from 'shared/http/native-http-interceptor';

export function translateLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

import { pageTransition } from './page-transition';
import { UserRepository } from './profile/repositories/user.repository';
import { HyphenateService } from 'shared/helpers/hyphenate.service';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { CModuleModule } from './cmodule/cmodule.module';

initializeApp(environment.firebase);

export function appInitializerFactory(translateService: TranslateService) {
  return () => {
    translateService.setDefaultLang('en');
    return translateService.use('de').toPromise();
  };
}

const getConfig = () => {
  let config: IonicConfig = {
    navAnimation: pageTransition,
  };

  if (isPlatform('ios')) {
    let lang: string;

    if (navigator.language) {
      // console.log('navigator.language: ' + navigator.language);
      lang = navigator.language.split('-')[0];
    } else {
      // console.log('fallback language: ' + defaultLang);
      lang = 'de';
    }
    config = {
      ...config,
      backButtonText: lang === 'de' ? 'Zurück' : 'Back',
    };
  }

  return config;
};

class CustomTranslateParser extends TranslateDefaultParser {
  constructor(private _hyphenateService: HyphenateService) {
    super();
  }

  override getValue(target: any, key: string): any {
    if ( this._hyphenateService.getTargetGroup() !== undefined ) {
      const res = super.getValue(target, key +'@' + this._hyphenateService.getTargetGroup());
      if ( res !== undefined) {
        console.log("key: " + key +'@' + this._hyphenateService.getTargetGroup() + " " + res);
        return res;
      }
    }
    if ( this._hyphenateService.getTheme() !== undefined ) {
      const res = super.getValue(target, key +'@' + this._hyphenateService.getTheme());
      if ( res !== undefined) {
        console.log("key: " + key +'@' + this._hyphenateService.getTheme() + " " + res);
        return res;
      }
    }
    return super.getValue(target, key);
  }

  override interpolate(expr: string | Function, params?: any): string {
    const s = super.interpolate(expr, params);
    if ( s === undefined) {
      return '';
    }
    return this._hyphenateService.hyphenate(s);
  }
}

@NgModule({
  declarations: [AppComponent],
///#   entryComponents: [],
  imports: [
    BrowserModule,
    // IonicModule.forRoot(/*{
    //   navAnimation: myTransitionAnimation}*/),
    IonicModule.forRoot(getConfig()),
    AppRoutingModule,
    HttpClientModule,
/*    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: translateLoaderFactory,
          deps: [HttpClient],
      },
    }),*/
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: translateLoaderFactory,
        deps: [HttpClient],
      },
      parser: {
        provide: TranslateParser,
        useClass: CustomTranslateParser,
        deps: [HyphenateService],
      },
    }),
    IonicStorageModule.forRoot(),
    ApptextModule,
    LeadaComponentsModule,
    LoginModule,
    DashboardModule,
    DialogsModule,
    DaytimeModule,
    ProfileModule,
    MenuModule,
    HistoryModule,
    TipsModule,
    BadgeModule,
    ContentModule,
    CModuleModule,
    InsightsModule,
    SearchModule,
  ],
  providers: [
    AuthRequest,
    HTTP,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NativeHttpInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslateService],
      multi: true,
    },
    File,
    FileOpener,
    FCMService,
    LocalSettingsService,
    CredentialsService,
    NavService,
    ScreenOrientation,
    LaunchReview,
    UserRepository,
    UserService,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
